import React from 'react';
import { setResumeData } from '../../actions/resume';
import { connect } from 'react-redux';
import Spinner from '../Spinner';
import Resume from '../Resume';
import { AlbumList, Cover, MusicActions, Separator } from '../../packages/components';
import { addToContextMenu } from '../..//actions/musica/context-menu-actions';
import { AAFPLAYER_PLAY } from '../../AAFPlayer/constants';
import { doPGMAlbum } from '../..//actions/musica/player-shared-action-creators';
import { playFullMedia } from '../../actions/playmedia';
import ContextMenu from '../ContextMenu';
import Device from '../../devices/device';
import MusicUtils from '../../actions/musica/music-actions';
import * as api from '../../requests/loader';
import PlayerTracksUtil from '../../utils/PlayerTracksUtils';
import PLAYERTRACK_TYPE from '../../containers/Music/playerTracksType';
import LayersControl from '../../utils/LayersControl';
import observer from '../../utils/MusicDetailPlayerObserver';

const mapDispatchToProps = dispatch => ({
    setResumeData: data => dispatch(setResumeData(data)),
    addToContextMenu: currentContent => dispatch(addToContextMenu(currentContent)),
    doPGMAlbum: (index, state) => dispatch(doPGMAlbum(index, state)),
    playFullMedia: pgm => dispatch(playFullMedia(pgm))
});

class NewAlbumDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            albumId: props.match.params.groupId,
            data: null,
            selectedVolume: null,
            selectedSong: null,
            components: [],
            isFetching: true
        };
        this.handlePlayClick = this.handlePlayClick.bind(this);
        this.handleToggleFollowClick = this.handleToggleFollowClick.bind(this);
        this.handleMoreClick = this.handleMoreClick.bind(this);
        this.handleAlbumListOnClick = this.handleAlbumListOnClick.bind(this);
        this.handleAlbumListOnFocus = this.handleAlbumListOnFocus.bind(this);
        this.handleAlbumListOnBlur = this.handleAlbumListOnBlur.bind(this);
        this.getIndexInVolume = this.getIndexInVolume.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.keys = Device.getDevice().getKeys();
        this.contextMenu = null;
        this.getData = this.getData.bind(this);
        this.setComponentState = this.setComponentState.bind(this);
        this.onToggleSongFavorite = this.onToggleSongFavorite.bind(this);
    }

    componentDidMount() {
        this.getData();
        observer.subscribe(this.onToggleSongFavorite);
    }

    componentWillUnmount() {
      observer.unsubscribe(this.onToggleSongFavorite);
    }

  async onToggleSongFavorite(changed) {
      const data = await this.state.data;
      if(data && data.volumes) {
        data.volumes = data.volumes.map(volume => ({
          ...volume, tracks: volume.tracks.map(track => {
            if(track.id === changed.trackId) {
              track.isFavorite = changed.isFavorite
            }
            return track;
          })
        }));
        this.setComponentState({
          isFetching: this.state.isFetching,
          data,
          components: this.state.components
        });
      }
    }

    setComponentState(response) {
      const {data, components, isFetching} = response;
      if(data && data.volumes) {
        data.isFollowed =
          !data.isFollowed ?
            data.volumes.reduce((acc, volume) => volume.tracks.every(track => track.isFavorite), false) :
            data.isFollowed;
        this.setResume(data);
        this.setState(
          {
            isFetching: isFetching,
            data,
            components: components
          },
          () => {
            window.SpatialNavigation.focus('.firstButton');
          }
        );
      }
    }

    async getData() {
        const { albumId } = this.state;
        const params = {
            album_id: albumId
        };
        const response = await api.getAlbumDetail(params);
        if (response && response.data && (response.data.isFollowed || response.data.volumes)) {
            this.setComponentState({
              isFetching: false,
              data: response.data,
              components: response.components
            });
        } else {
            this.setState({
                isFetching: false
            });
        }
    }

    setResume(data) {
        if (data) {
            const { setResumeData } = this.props;
            setResumeData({
                title: data.title,
                year: data.artist,
                rating: '',
                category: data.recorder,
                duration: data.year,
                description: '',
                showBack: false,
                purchaseButtonInfo: true,
                overWrite: true
            });
        }
    }

    onKeyDown(e) {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case 'BLUE':
                this.handlePlayClick();
                break;
            case 'PLAYPAUSE': // for new models samsung tizen small control
            case 'PAUSE':
            case 'PLAY':
                this.handlePlayClick();
                break;
            case 'GREEN':
                this.handleMoreClick();
                break;
            case 'YELLOW':
                this.handleToggleFollowClick();
                break;
            default:
                break;
        }
    }

    renderComponent(component) {
        if (!component || !component.properties || !component.name) {
            return null;
        }
        switch (component.name) {
            case 'Actions':
                const { data } = this.state;
                const props = { ...component.properties };
                if (data.isFollowed) {
                    props.toggleFollow = props.unfollow;
                } else {
                    props.toggleFollow = props.follow;
                }
                delete props.follow;
                delete props.unfollow;
                return (
                    <MusicActions
                        {...props}
                        onToggleFollowClick={this.handleToggleFollowClick}
                        onPlayClick={this.handlePlayClick}
                        onMoreClick={this.handleMoreClick}
                        onKeyDown={this.onKeyDown}
                        device={MusicUtils.getMusicDevice()}
                    />
                );
            case 'Cover':
                return <Cover {...component.properties} />;
            case 'SongList':
                return (
                    <AlbumList
                        {...component.properties}
                        onClick={this.handleAlbumListOnClick}
                        onFocus={this.handleAlbumListOnFocus}
                        onBlur={this.handleAlbumListOnBlur}
                        device={MusicUtils.getMusicDevice()}
                    />
                );
            default:
                return null;
        }
    }

    handlePlayClick(index = 0) {
        const { albumId, data: { volumes = [] } = {} } = this.state;
        const { doPGMAlbum, playFullMedia } = this.props;
        if (volumes.length > 0) {
            // ejecutando la llamada
            const playerTracks = new PlayerTracksUtil();
            playerTracks.getPlayerTracks(PLAYERTRACK_TYPE.ALBUM, albumId).then(resp => {
                const pgm_musica = doPGMAlbum(index, {
                    volumes,
                    playerTracks: resp
                });
                if (pgm_musica && pgm_musica.media && pgm_musica.media.video_url) {
                    playFullMedia({
                        playerstate: AAFPLAYER_PLAY,
                        source: {
                            audiosource: pgm_musica.media.video_url
                        },
                        ispreview: false,
                        islive: false,
                        ispip: false
                    });
                }
            });
        }
    }

    handleToggleFollowClick() {
        const { components, data } = this.state;
        const [actionsComponent] = components;
        let url = '';
        if (data.isFollowed) {
            url = actionsComponent.properties.follow.url;
        } else {
            url = actionsComponent.properties.unfollow.url;
        }
        const headers = {};
        api.simpleCMMRequest(url, headers).then(success => {
            if (success) {
                this.setState(prevState => ({
                    data: { ...prevState.data, isFollowed: !prevState.data.isFollowed }
                }));
            }
        });
    }

    handleMoreClick() {
        if (LayersControl.isPlayerVisible()) return;
        const el = document.getElementById('w_canciones').querySelector('.focusable:focus');
        const { albumId, selectedVolume, selectedSong, data } = this.state;
        const { volumes = [] } = data;
        const { addToContextMenu } = this.props;
        if (el) {
            // it is just a song
            if (
                !isNaN(selectedSong) &&
                !isNaN(selectedVolume) &&
                volumes[selectedVolume] &&
                volumes[selectedVolume].tracks &&
                volumes[selectedVolume].tracks[selectedSong]
            ) {
                const song = volumes[selectedVolume].tracks[selectedSong];
                addToContextMenu({ song, type: PLAYERTRACK_TYPE.ALBUM, id: albumId });
            }
        } else {
            const [firstVolume] = volumes;
            if (firstVolume.tracks && firstVolume.tracks.length > 0) {
                addToContextMenu({
                    tracks: firstVolume.tracks,
                    type: PLAYERTRACK_TYPE.ALBUM,
                    id: albumId,
                    artists: data.artist,
                    artistId: data.artistId
                });
            }
        }
        const context = this.contextMenu.getWrappedInstance();
        context.showModal();
    }

    getIndexInVolume(volumeIndex, songIndex) {
        let index = 0;
        const {
            data: { volumes = [] }
        } = this.state;
        for (let i = 0; i < volumeIndex; i++) index += volumes[i].tracks.length;
        return index + songIndex;
    }

    handleAlbumListOnClick(song) {
        this.handlePlayClick(this.getIndexInVolume(song.volumeIndex, song.songIndex));
    }

    handleAlbumListOnFocus(song) {
        const el = document.getElementById(`song-${song.phonogramId}`);
        el.classList.add('selected-song');
        this.setState({ selectedSong: song.songIndex, selectedVolume: song.volumeIndex });
    }

    handleAlbumListOnBlur(song) {
        const el = document.getElementById(`song-${song.phonogramId}`);
        el.classList.remove('selected-song');
        this.setState({ selectedSong: song.songIndex, selectedVolume: song.volumeIndex });
    }

    render() {
        const { components } = this.state;
        const [actionsComponent, coverComponent, songListComponent] = components;
        return (
            <div className="album_resume_container">
                {this.state.isFetching ? (
                    <Spinner />
                ) : (
                    <div className="album_container">
                        <Resume />
                        {this.renderComponent(actionsComponent)}
                        <Separator />
                        <div className="w_detail">
                            <div className="w_album">
                                <div>{this.renderComponent(coverComponent)}</div>
                            </div>
                            <div className="w_canciones" id="w_canciones">
                                {this.renderComponent(songListComponent)}
                            </div>
                        </div>
                    </div>
                )}
                <ContextMenu
                    ref={instance => {
                        this.contextMenu = instance;
                    }}
                />
            </div>
        );
    }
}

export default connect(null, mapDispatchToProps)(NewAlbumDetail);



// WEBPACK FOOTER //
// ./src/components/AlbumDetail/NewAlbumDetail.jsx